import React, { useState } from 'react'
import '../../css/OTPModal.scss'
import FormikControls from './FormikControls'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import _httpServices from '../../utils/_httpServices';
import { getRedirectUrl } from '../../utils/helpter';
import AlertModal from './AlertModal';
const OTPModal = (props) => {
    const { data, onClose = () => { }, } = props
    const [showAlert, setShowAlert] = useState({
        open: false,
        msg: ''
    })
    const initialValues = {
        ODP: ''
    };
    const validationSchema = Yup.object({
        ODP: Yup.number().required("required"),
    });

    const handleLogin = (value) => {
        const body = {
            ODP: value?.ODP,
            Code: data?.code,
            LoginID: data?.username,
            Password: data?.password
        }
        const path = window.location.pathname;
        const isCargo = path.startsWith("/cargo");
        const url = isCargo ? '/Login' : '/LoginV2/Login';
        _httpServices.HttpCall(url, 'Post', {}, body, isCargo ? "AmxsG7zkJB" : null).then((response) => {
            if (response.status === 200 && response.data.Status === "true") {
                window.location.replace(getRedirectUrl(isCargo ? { ...data, ODP: value?.ODP} : data));
                return false;
            } else {
                setShowAlert((prev) => ({
                    open: true,
                    msg: response.data.ErrMessage || ''
                }))
            }
        })
    }

    const handleResetOTP = () => {
        const body = {
            LoginID: data?.username,
            Code: data?.code,
            check: 0
        }
        const path = window.location.pathname;
        const isCargo = path.startsWith("/cargo");
        const url = isCargo ? '/LoginODP/GetOneDayPassword' : '/LoginV2/GetOneDayPassword';
        _httpServices.HttpGet(url, body, isCargo ? "AmxsG7zkJB" : null).then((res) => {
            if (res?.data?.status || res?.data?.Message === null) {

            } else {
                setShowAlert((prev) => ({
                    ...prev,
                    open: true,
                    msg: res?.data?.Message
                }))
            }
        })
    }
    return (
        <>
            <div className="modal-overlay" id="modalOverlay">
                <div className='container'>
                    <div className='header-section'>
                        <div>
                            Enter One Day Password
                        </div>
                        <div className='closeIcon' onClick={onClose}>
                            &times;
                        </div>
                    </div>
                    <div className='middle-section'>
                        <div>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={(value) => {
                                    handleLogin(value)
                                }}
                            >
                                {({ values, setFieldValue, submitForm }) => {
                                    return (
                                        <Form>
                                            <div className="input--Modal--wrapper">
                                                <FormikControls
                                                    id="ODP"
                                                    control="input"
                                                    type="number"
                                                    name="ODP"
                                                    label="One Day Password (ODB)"
                                                    autoFocus={true}
                                                    autoComplete="off"
                                                    style={{}}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            submitForm()
                                                        }
                                                    }}

                                                />
                                            </div>
                                            <div className='button-container' style={{ marginTop: '16px' }}>
                                                <button onClick={submitForm}>login</button>
                                            </div>
                                        </Form>
                                    )
                                }}
                            </Formik>
                        </div>

                        <div className='resend-btn' onClick={handleResetOTP}>
                            <div>
                                Resend ODP
                            </div>
                        </div>
                    </div>
                    <div className='bottom-section'>
                        <p>
                            Today's one day password has been generated. SMS sent to {data?.MobileNo || ''}.
                        </p>
                    </div>
                </div>
            </div>
            {showAlert?.open && <AlertModal msg={showAlert?.msg} onClose={() => {
                setShowAlert({
                    open: false,
                    msg: ''
                })
            }} />}
        </>
    )
}

export default OTPModal